var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternetAntenna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeWidth: 0.691,
    d: "M2.532 11.456a6.144 6.144 0 1 1 9.83 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeWidth: 0.691,
    d: "M4.7 10.226a3.686 3.686 0 1 1 5.495 0M7.447 7.769v6.143m-1.843 0H9.29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "M0 0h14.745v14.745H0z",
    transform: "translate(.074 .396)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetAntenna);
export default __webpack_public_path__ + "static/media/internet-antenna.fc5ef0af.svg";
export { ForwardRef as ReactComponent };